function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M128.542 121.85C151.644 98.7156 151.644 61.2073 128.542 38.0729C105.44 14.9385 67.9848 14.9385 44.8831 38.0729C21.7814 61.2073 21.7814 98.7156 44.8831 121.85C67.9848 144.984 105.44 144.984 128.542 121.85Z",
  fill: "#F2F2F2"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.73,
  d: "M134.929 94.1373V114.106C132.746 117.149 130.277 120.001 127.618 122.664V94.1373C127.618 93.9471 124.01 90.9994 121.256 88.8123V87.4811L124.579 86.6253C125.909 86.245 127.333 86.4351 128.663 86.9106C129.232 87.1958 129.802 87.386 130.467 87.5762V90.1436C133.22 92.5208 134.929 93.9471 134.929 94.1373Z",
  fill: "#E0E0E0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.56384 3.99365L19.9404 44.7865L32.5693 36.0384L39.9757 46.7833L41.305 28.7166L56.5926 19.3979L2.56384 3.99365Z",
  fill: "url(#paint0_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.4178 34.1366L19.9404 44.7865L32.5692 36.0384L39.9756 46.7833L41.305 28.7166L16.8069 14.1681L35.4178 34.1366Z",
  fill: "#FF9433"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.9252 33.1857L16.8069 14.1681L41.305 28.7166L40.9252 33.1857Z",
  fill: "#FF7733"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.2604 51.823C40.1655 51.0623 39.9756 50.2065 39.7856 49.4458L41.02 49.1605C41.21 49.9212 41.3999 50.777 41.5898 51.6328L40.2604 51.823Z",
  fill: "url(#paint1_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.9224 79.4936C24.1183 79.3986 22.4091 78.828 20.9848 77.8771L21.6495 76.8312C22.8839 77.687 24.4031 78.1624 26.0173 78.2575L25.9224 79.4936ZM30.9549 78.5428L30.3852 77.4017C31.6196 76.7361 32.949 75.7852 34.0884 74.454L35.038 75.3098C33.8036 76.7361 32.3793 77.7821 30.9549 78.5428ZM17.4715 73.9785C16.8068 72.5522 16.427 71.0308 16.427 69.5094C16.427 69.4143 16.427 69.2241 16.427 69.129V68.8438L17.6614 68.9389V69.129C17.6614 69.2241 17.6614 69.3192 17.6614 69.4143C17.6614 70.7455 17.9463 72.0768 18.6109 73.3129L17.4715 73.9785ZM65.1383 73.6933V72.4571C66.7526 72.4571 68.3668 72.362 70.0759 72.2669L70.1709 73.5031C68.4617 73.5982 66.7526 73.5982 65.1383 73.6933ZM60.2007 73.5031L59.4411 73.408C57.9218 73.3129 56.5925 73.1227 55.2631 72.8375L55.453 71.6013C56.6874 71.7915 58.0168 71.9817 59.5361 72.0768L60.2957 72.1719L60.2007 73.5031ZM75.1085 72.9326L74.9186 71.6964C76.5328 71.5062 78.147 71.221 79.7612 70.9357L79.9511 72.1719C78.3369 72.4571 76.7227 72.7424 75.1085 72.9326ZM50.3255 71.6964C48.9012 71.221 47.4769 70.5554 46.3375 69.8897C46.1476 69.7947 45.9577 69.6996 45.7678 69.5094L46.4324 68.4634C46.6223 68.5585 46.8122 68.6536 47.0022 68.7487C48.1416 69.4143 49.471 69.9848 50.8003 70.4603L50.3255 71.6964ZM37.9815 71.221L36.937 70.6504C37.6967 69.2241 38.4563 67.7978 38.9311 66.2764L40.0705 66.6567C39.5008 68.1782 38.8361 69.6996 37.9815 71.221ZM84.8888 71.0308L84.6039 69.7947C86.1232 69.4143 87.7374 69.0339 89.3516 68.5585L89.7314 69.6996C88.0222 70.2701 86.408 70.6504 84.8888 71.0308ZM94.4791 68.3683L94.0993 67.2273C95.6185 66.7518 97.2327 66.1813 98.752 65.6108L99.1318 66.7518C97.6126 67.3224 95.9983 67.7978 94.4791 68.3683ZM41.5898 66.6567C40.4503 65.8009 39.2159 64.9452 37.8866 64.2795L37.5068 64.0894L38.0765 62.9483C38.2664 63.0434 38.3613 63.1385 38.5513 63.1385C39.9756 63.8992 41.21 64.8501 42.3494 65.6108L41.5898 66.6567ZM19.4655 64.8501L18.6109 63.9943C19.6554 62.9483 21.1747 62.0925 23.1687 61.522L23.5485 62.663C21.6495 63.2336 20.3201 63.8992 19.4655 64.8501ZM32.949 62.4729C31.5247 62.1876 30.1004 61.9974 28.6761 61.9974H28.2013V60.7613C29.9105 60.7613 31.6196 60.8564 33.2338 61.2367L32.949 62.4729ZM41.3999 61.7122L40.1655 61.522C40.4503 59.9055 40.6402 58.289 40.6402 56.6725H41.8746C41.8746 58.3841 41.6847 60.0006 41.3999 61.7122Z",
  fill: "url(#paint2_linear)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M103.88 64.9451L103.405 63.804C104.164 63.5188 104.924 63.2335 105.684 62.9482L106.158 64.0893C105.399 64.3746 104.639 64.6598 103.88 64.9451Z",
  fill: "url(#paint3_linear)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M142.621 94.993C141.956 94.993 141.481 94.5176 141.386 93.8519C141.291 93.1863 141.861 92.6158 142.526 92.5207C149.932 91.76 156.769 88.2417 161.801 82.5365C162.276 82.061 163.036 81.9659 163.511 82.4414C163.985 82.9168 164.08 83.6775 163.606 84.153C158.193 90.3337 150.787 94.2323 142.716 94.993C142.716 94.993 142.716 94.993 142.621 94.993Z",
  fill: "url(#paint4_linear)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M127.618 94.1372L84.6988 119.431L41.8746 94.1372V94.0422C41.8746 93.852 44.2485 91.8551 47.8567 89.0025L47.9517 88.9074C59.8209 79.3035 84.6988 59.6202 84.6988 59.6202C84.6988 59.6202 109.672 79.3035 121.446 89.0025C125.149 91.9502 127.618 93.9471 127.618 94.1372Z",
  fill: "#7A4C08"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M102.36 38.6057H56.1177C52.1297 38.6057 48.9012 41.8387 48.9012 45.8324V115.912C48.9012 119.906 52.1297 123.139 56.1177 123.139H114.135C118.123 123.139 121.351 119.906 121.351 115.912V57.5283L102.36 38.6057Z",
  fill: "white"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M102.36 50.3016C102.36 54.2953 105.589 57.5283 109.577 57.5283H121.256L102.36 38.6057V50.3016Z",
  fill: "#E6E8E8"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M78.3369 50.4917H62.3847C60.9604 50.4917 59.8209 51.6328 59.8209 53.0591V69.0339C59.8209 70.4602 60.9604 71.6013 62.3847 71.6013H78.3369C79.7612 71.6013 80.9007 70.4602 80.9007 69.0339V53.0591C80.9007 51.6328 79.7612 50.4917 78.3369 50.4917Z",
  fill: "#F2F2F2"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M100.271 77.4017H61.9099C60.7705 77.4017 59.8209 78.3526 59.8209 79.4937C59.8209 80.6347 60.7705 81.5856 61.9099 81.5856H100.271C101.411 81.5856 102.36 80.6347 102.36 79.4937C102.36 78.3526 101.411 77.4017 100.271 77.4017Z",
  fill: "#F2F2F2"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M100.271 87.7662H61.9099C60.7705 87.7662 59.8209 88.7171 59.8209 89.8582C59.8209 90.9992 60.7705 91.9501 61.9099 91.9501H100.271C101.411 91.9501 102.36 90.9992 102.36 89.8582C102.36 88.622 101.411 87.7662 100.271 87.7662Z",
  fill: "#F2F2F2"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M82.8947 97.7505H62.0049C60.8654 97.7505 59.9159 98.7014 59.9159 99.8424C59.9159 100.983 60.8654 101.934 62.0049 101.934H82.8947C84.0342 101.934 84.9837 100.983 84.9837 99.8424C84.8888 98.6063 84.0342 97.7505 82.8947 97.7505Z",
  fill: "#F2F2F2"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M127.618 94.1372V135.31C127.618 138.163 125.244 140.54 122.396 140.54H47.0971C44.2485 140.54 41.8746 138.163 41.8746 135.31V94.1372L84.7938 119.431L127.618 94.1372Z",
  fill: "url(#paint5_linear)"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M126.194 139.019L98.5621 111.348L84.6988 119.526L70.8356 111.348L43.204 139.019C44.1535 140.065 45.4829 140.635 47.0021 140.635H122.396C123.915 140.635 125.244 139.97 126.194 139.019Z",
  fill: "#FF9433"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M136.259 37.5598C123.915 38.796 114.04 48.9704 113.185 61.3319C112.71 67.5126 114.514 73.2179 117.743 77.8772C118.977 79.5888 119.167 81.8709 118.313 83.8678L116.319 88.8124L124.674 86.6253C126.004 86.245 127.428 86.3401 128.757 86.9106C132.651 88.6222 136.924 89.3829 141.576 88.9074C153.73 87.7664 163.511 77.9723 164.65 65.801C166.169 49.5409 152.591 36.0384 136.259 37.5598Z",
  fill: "url(#paint6_linear)"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M139.582 76.3558L141.007 74.9295C141.007 74.9295 139.867 72.267 144.615 67.7979C147.463 65.1354 148.033 62.568 147.843 60.4761C147.463 57.148 144.71 54.3904 141.386 54.0101C139.297 53.8199 136.734 54.3904 134.075 57.2431C129.612 61.9975 126.953 60.8564 126.953 60.8564L125.529 62.2827L139.582 76.3558Z",
  fill: "white"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M128.662 67.6077C127.523 69.1291 127.713 71.3161 129.042 72.6473C130.372 73.9786 132.556 74.1688 134.075 73.0277L128.662 67.6077Z",
  fill: "white"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.793 55.6265L147.938 56.4823C147.273 55.4364 146.324 54.4855 145.185 53.8199L146.039 52.9641C146.799 52.2034 148.033 52.2034 148.793 52.9641C149.457 53.7248 149.457 54.8658 148.793 55.6265Z",
  fill: "white"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M138.253 37.4647C147.463 40.2223 154.11 48.6851 154.11 58.8596C154.11 71.221 144.14 81.2053 131.796 81.2053C125.339 81.2053 119.547 78.4477 115.464 73.9786C116.129 75.4049 116.888 76.7361 117.743 77.9723C118.977 79.6839 119.167 81.966 118.313 83.9628L116.319 88.9074L124.674 86.7204C126.004 86.34 127.428 86.4351 128.757 87.0057C132.651 88.7172 136.924 89.4779 141.576 89.0025C153.73 87.8614 163.511 78.0674 164.65 65.8961C166.074 50.2065 153.635 37.0844 138.253 37.4647Z",
  fill: "#242424",
  fillOpacity: 0.1
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.98809 16.0698L9.59037 29.0018C9.87523 29.6674 9.59037 30.4281 8.9257 30.7134L8.73579 30.8085C8.07111 31.0938 7.31148 30.8085 7.02662 30.1429L1.61425 17.1158C1.32939 16.4502 1.7092 15.6895 2.37388 15.4042C3.03856 15.119 3.79819 15.4042 3.98809 16.0698Z",
  fill: "#FFB031"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.1124 107.069C23.8335 107.069 21.9344 108.971 21.9344 111.253C21.9344 113.535 23.8335 115.437 26.1124 115.437C28.3913 115.437 30.2904 113.535 30.2904 111.253C30.1954 108.971 28.3913 107.069 26.1124 107.069ZM26.1124 112.87C25.1629 112.87 24.4032 112.109 24.4032 111.158C24.4032 110.207 25.1629 109.447 26.1124 109.447C27.062 109.447 27.8216 110.207 27.8216 111.158C27.7266 112.109 26.967 112.87 26.1124 112.87Z",
  fill: "#F2F2F2"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M136.924 123.805C134.645 123.805 132.746 125.707 132.746 127.989C132.746 130.271 134.645 132.173 136.924 132.173C139.202 132.173 141.102 130.271 141.102 127.989C141.102 125.707 139.202 123.805 136.924 123.805ZM136.924 129.7C135.974 129.7 135.214 128.94 135.214 127.989C135.214 127.038 135.974 126.277 136.924 126.277C137.873 126.277 138.633 127.038 138.633 127.989C138.633 128.94 137.873 129.7 136.924 129.7Z",
  fill: "#F2F2F2"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M170.727 59.5253C169.018 59.5253 167.594 60.9516 167.594 62.6632C167.594 64.3748 169.018 65.8011 170.727 65.8011C172.436 65.8011 173.861 64.3748 173.861 62.6632C173.956 60.9516 172.531 59.5253 170.727 59.5253ZM170.727 63.9944C170.062 63.9944 169.398 63.4239 169.398 62.6632C169.398 61.9976 169.967 61.3319 170.727 61.3319C171.392 61.3319 172.056 61.9025 172.056 62.6632C172.056 63.3288 171.487 63.9944 170.727 63.9944Z",
  fill: "#F2F2F2"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M114.989 8.74817C113.185 8.74817 111.666 10.2696 111.666 12.0763C111.666 13.8829 113.185 15.4043 114.989 15.4043C116.793 15.4043 118.313 13.8829 118.313 12.0763C118.313 10.2696 116.888 8.74817 114.989 8.74817ZM114.989 13.5026C114.23 13.5026 113.66 12.932 113.66 12.1713C113.66 11.4106 114.23 10.8401 114.989 10.8401C115.749 10.8401 116.319 11.4106 116.319 12.1713C116.319 12.837 115.749 13.5026 114.989 13.5026Z",
  fill: "#F2F2F2"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.88121 86.9106C5.98214 86.9106 4.36792 88.5271 4.36792 90.4289C4.36792 92.3307 5.98214 93.9472 7.88121 93.9472C9.78029 93.9472 11.3945 92.3307 11.3945 90.4289C11.3945 88.4321 9.78029 86.9106 7.88121 86.9106Z",
  fill: "#F2F2F2"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M149.173 98.6064C147.748 98.6064 146.609 99.7475 146.609 101.174C146.609 102.6 147.748 103.741 149.173 103.741C150.597 103.741 151.736 102.6 151.736 101.174C151.736 99.7475 150.597 98.6064 149.173 98.6064Z",
  fill: "#F2F2F2"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M64.3788 9.79407C62.2898 9.79407 60.6756 11.5057 60.6756 13.5025C60.6756 15.4994 62.3848 17.2109 64.3788 17.2109C66.4678 17.2109 68.082 15.4994 68.082 13.5025C68.082 11.5057 66.3728 9.79407 64.3788 9.79407Z",
  fill: "#F2F2F2"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.4141 145.58C82.8948 145.58 81.6604 146.816 81.6604 148.338C81.6604 149.859 82.8948 151.095 84.4141 151.095C85.9333 151.095 87.1677 149.859 87.1677 148.338C87.0728 146.816 85.8384 145.58 84.4141 145.58Z",
  fill: "#F2F2F2"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M137.208 24.2476C135.404 24.2476 133.98 25.6739 133.98 27.4806C133.98 29.2872 135.404 30.7136 137.208 30.7136C139.013 30.7136 140.437 29.2872 140.437 27.4806C140.342 25.6739 138.918 24.2476 137.208 24.2476Z",
  fill: "#F2F2F2"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.7386 52.774C24.735 52.774 25.5427 51.9651 25.5427 50.9673C25.5427 49.9695 24.735 49.1606 23.7386 49.1606C22.7422 49.1606 21.9344 49.9695 21.9344 50.9673C21.9344 51.9651 22.7422 52.774 23.7386 52.774Z",
  fill: "#F2F2F2"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M171.867 43.5504C170.157 43.5504 168.733 44.9767 168.733 46.6883C168.733 48.3999 170.157 49.8262 171.867 49.8262C173.576 49.8262 175 48.3999 175 46.6883C175 44.8816 173.576 43.5504 171.867 43.5504Z",
  fill: "#F2F2F2"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.17201 63.9943C7.27328 63.9943 8.16604 63.1003 8.16604 61.9975C8.16604 60.8946 7.27328 60.0006 6.17201 60.0006C5.07074 60.0006 4.17798 60.8946 4.17798 61.9975C4.17798 63.1003 5.07074 63.9943 6.17201 63.9943Z",
  fill: "#F2F2F2"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M89.5416 3.13794L90.776 1.90179C91.2507 1.42635 91.2507 0.760732 90.776 0.285292C90.3012 -0.190149 89.6365 -0.190149 89.1618 0.285292L87.9274 1.52144L86.693 0.285292C86.2182 -0.190149 85.5535 -0.190149 85.0787 0.285292C84.604 0.760732 84.604 1.42635 85.0787 1.90179L86.4081 3.13794L85.1737 4.37408C84.6989 4.84952 84.6989 5.51514 85.1737 5.99058C85.6485 6.46602 86.3131 6.46602 86.7879 5.99058L87.9274 4.75444L89.1618 5.99058C89.6365 6.46602 90.3012 6.46602 90.776 5.99058C91.2507 5.51514 91.2507 4.84952 90.776 4.37408L89.5416 3.13794Z",
  fill: "#F2F2F2"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.74774 40.8879L5.98214 39.6518C6.45691 39.1764 6.45691 38.5107 5.98214 38.0353C5.50737 37.5599 4.8427 37.5599 4.36793 38.0353L3.13353 39.2714L1.89913 38.0353C1.42436 37.5599 0.759679 37.5599 0.28491 38.0353C-0.189859 38.5107 -0.189859 39.1764 0.28491 39.6518L1.61426 40.8879L0.379864 42.1241C-0.0949055 42.5995 -0.0949055 43.2651 0.379864 43.7406C0.854633 44.216 1.51931 44.216 1.99408 43.7406L3.22848 42.5044L4.46288 43.7406C4.93765 44.216 5.60233 44.216 6.0771 43.7406C6.55187 43.2651 6.55187 42.5995 6.0771 42.1241L4.74774 40.8879Z",
  fill: "#F2F2F2"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M151.641 117.054L152.686 116.008C153.066 115.627 153.066 115.057 152.686 114.676C152.306 114.296 151.736 114.296 151.357 114.676L150.312 115.722L149.268 114.676C148.888 114.296 148.318 114.296 147.938 114.676C147.558 115.057 147.558 115.627 147.938 116.008L148.983 117.054L147.938 118.1C147.558 118.48 147.558 119.05 147.938 119.431C148.318 119.811 148.888 119.811 149.268 119.431L150.312 118.385L151.357 119.431C151.736 119.811 152.306 119.811 152.686 119.431C153.066 119.05 153.066 118.48 152.686 118.1L151.641 117.054Z",
  fill: "#F2F2F2"
});

var _ref40 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 14.0415,
  y1: 3.99365,
  x2: 50.4433,
  y2: 10.9415,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 40.6877,
  y1: 49.1605,
  x2: 40.6877,
  y2: 51.8046,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0A49FA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#286FF9"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 57.7794,
  y1: 56.6725,
  x2: 57.7794,
  y2: 79.3363,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0A49FA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#286FF9"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 104.782,
  y1: 62.9482,
  x2: 104.782,
  y2: 64.9313,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0A49FA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#286FF9"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 152.647,
  y1: 82.1288,
  x2: 152.647,
  y2: 94.9043,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0A49FA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#286FF9"
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 60.0895,
  y1: 94.1372,
  x2: 115.63,
  y2: 109.651,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 138.938,
  y1: 37.4426,
  x2: 138.938,
  y2: 88.6908,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0A49FA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#286FF9"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 175,
    height: 151,
    viewBox: "0 0 175 151",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40);
};

export default __webpack_public_path__ + "static/media/frame.566ca891.svg";
export { SvgComponent as ReactComponent };